
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

interface NavLinksProps {
  canViewDocs: boolean;
  isAdmin: boolean;
  isMobile?: boolean;
  onItemClick?: () => void;
}

const NavLinks = ({ canViewDocs, isAdmin, isMobile = false, onItemClick }: NavLinksProps) => {
  return (
    <nav className={`${isMobile ? "flex flex-col gap-4" : "flex items-center gap-6"} text-sm`}>
      <Link 
        to="/dashboard" 
        className="transition-colors hover:text-fraudeye-accent py-2"
        onClick={onItemClick}
      >
        Dashboard
      </Link>
      {canViewDocs && (
        <Link 
          to="/documentation" 
          className="transition-colors hover:text-fraudeye-accent py-2"
          onClick={onItemClick}
        >
          <span className="flex items-center">
            <FileText className="h-4 w-4 mr-1" />
            Internal Docs
          </span>
        </Link>
      )}
      {isAdmin && (
        <Link 
          to="/admin" 
          className="transition-colors hover:text-fraudeye-accent py-2"
          onClick={onItemClick}
        >
          Admin
        </Link>
      )}
    </nav>
  );
};

export default NavLinks;
